export default __webpack_public_path__ + "static/media/connectivity_red.0cfd8e0f.svg";